import React from "react";

import { Banner, Courses, Facts, Instructor } from "../components";

const Home = () => {
  return (
    <>
      <Banner />
      <Facts />
      <Courses />
      
    </>
  );
};

export default Home;
